/**
 * Item selector for tree item
 */
export const TREE_ITEM_SELECTOR = '[data-oj-tree-item]';
